import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VisserModule } from '@application/common/enums/visser-module';
import { useAppSelector } from '@application/store/useStore';
import { AiOutlineInfoCircle, AiOutlineReload } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
const PersistentInfoMessage = ({ recordId, moduleId }) => {
    const { updateModulePermissionStatus } = useAppSelector((state) => state.workorder);
    const navigate = useNavigate();
    // const [isMinimized, setIsMinimized] = useState(false);
    // Toggle between minimized and maximized states
    const handleToggleRefresh = () => {
        if (moduleId == VisserModule.Werkorder) {
            window.location.href = `/admin/WorkordersTabs/${recordId}`;
        }
        if (moduleId == VisserModule.Offertes) {
            window.location.href = `/admin/QuotationTabs/${recordId}`;
        }
        if (moduleId == VisserModule.Facturen) {
            window.location.href = `/admin/InvoiceTabs/${recordId}`;
        }
        if (moduleId == VisserModule.Bestellingen) {
            window.location.href = `/admin/OrderTabs/${recordId}`;
        }
        if (moduleId == VisserModule.Inkoopfacturen) {
            window.location.href = `/admin/PurchaseInvoicesTabs/${recordId}`;
        }
    };
    return (_jsx("div", { className: `toaster-info-container`, children: _jsxs("div", { className: 'toaster-info-content', children: [_jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col-1', children: _jsx(AiOutlineInfoCircle, { size: 20, style: { marginRight: '8px' } }) }), _jsxs("div", { className: 'col-11', children: [_jsx("strong", { children: "U bent in alleen-lezen modus!" }), _jsxs("p", { className: 'mt-2', children: ["Gebruiker : ", updateModulePermissionStatus?.userIdentifier, "  is momenteel bezig met het bewerken van de werkopdracht, wijzigingen die u aanbrengt worden niet opgeslagen."] })] })] }), _jsx("span", { onClick: handleToggleRefresh, className: 'custom-toaster-info-close-button', children: _jsx(AiOutlineReload, { size: 20, style: { marginRight: '8px' } }) })] }) }));
};
export default PersistentInfoMessage;
